// Port of api/fuel/app/classes/insights/plays/types.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'types',
    insight: ['type'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var types = []
        var typeFilter = filter.type || 'category'
        var table = (typeFilter === 'category') ? 'category' : 'mechanic'

        var exclude = (typeFilter === 'category') ? [1042, 1044] : []
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''
        var limit = detail ? 100 : 5

        var excludeSql = exclude.length ? ' AND l.' + table + '_id NOT IN(' + Util.in(exclude) + ')' : ''

        var rankedTypes = Util.queryFast(
            'SELECT l.' + table + '_id AS t,' +
            " group_concat(DISTINCT l.game_id) AS g," +
            ' SUM(p.play_count) AS c,' +
            ' t.' + table + '_name AS n' +
            ' FROM game_' + table + ' l, ' + table + ' t, game g, play p' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date < ' + range.end +
            ' AND p.game_id = g.game_id' +
            ' AND l.game_id = g.game_id' +
            ' AND t.' + table + '_id = l.' + table + '_id' +
            ' AND g.game_id = l.game_id' +
            ' AND g.game_type = 1' +
            excludeSql +
            sqlCount +
            ' GROUP BY l.' + table + '_id' +
            ' ORDER BY SUM(p.play_count) DESC, t.' + table + '_name ASC' +
            ' LIMIT 0, ' + limit
        )

        if (!rankedTypes.length) return {}

        var typeIndex = []
        var gameIndex = []

        for (var ri = 0; ri < rankedTypes.length; ri++) {
            typeIndex.push(parseInt(rankedTypes[ri].t, 10))
            var gParts = rankedTypes[ri].g ? rankedTypes[ri].g.split(',') : []
            for (var gj = 0; gj < gParts.length; gj++) {
                if (gParts[gj] !== '' && gameIndex.indexOf(gParts[gj]) === -1) {
                    gameIndex.push(gParts[gj])
                }
            }
        }

        if (!gameIndex.length) gameIndex = [0]
        if (!typeIndex.length) typeIndex = [0]

        var typeGames = Util.queryFast(
            'SELECT l.' + table + '_id AS t,' +
            ' l.game_id AS g,' +
            ' AVG(r.rating_value) AS r' +
            ' FROM game_' + table + ' l' +
            ' LEFT JOIN rating r ON r.game_id = l.game_id' +
            ' AND r.user_id IN(' + Util.in(userIndex) + ')' +
            ' WHERE l.' + table + '_id IN(' + Util.in(typeIndex) + ')' +
            ' AND l.game_id IN(' + Util.in(gameIndex) + ')' +
            ' GROUP BY l.' + table + '_id, l.game_id' +
            ' ORDER BY AVG(r.rating_value) DESC, l.game_id ASC',
            null, 't', true
        )

        for (var ti = 0; ti < rankedTypes.length; ti++) {
            var rankedType = rankedTypes[ti]
            var ratings = []

            var tGames = typeGames[rankedType.t] || []
            var sliced = tGames.slice(0, 3)

            for (var si = 0; si < sliced.length; si++) {
                var game = sliced[si]

                ratings.push({
                    id: parseInt(game.g, 10),
                    rating: game.r ? parseFloat(game.r) : '-'
                })

                this._references.games.push(parseInt(game.g, 10))
            }

            types.push({
                id: parseInt(rankedType.t, 10),
                name: rankedType.n,
                count: parseInt(rankedType.c, 10),
                games: ratings,
                gamesCount: tGames.length
            })
        }

        return {
            types: types
        }

    }
})
